// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hH-9","type":"styles_type__2aqmZ","choices":"styles_choices__1j58j"};